import { memo, useState } from 'react';
import { useTheme } from '../../features/theme/useTheme';

type LoginButtonProps = {
    text: string;
    icon: string;
    onClick: () => void;
    disabled?: boolean;
};

const LoginButton = memo(({ text, icon, onClick, disabled = false }: LoginButtonProps) => {
    const { themeMode } = useTheme();
    const isDark = themeMode === 'dark' ||
        (themeMode === 'auto' && window.matchMedia('(prefers-color-scheme: dark)').matches);
    const [isHovered, setIsHovered] = useState(false);

    return (
        <button
            onClick={onClick}
            disabled={disabled}
            onMouseEnter={() => !disabled && setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            style={isDark ? {
                backgroundColor: isHovered ? 'var(--color-primary-20)' : 'var(--color-primary-10)',
                borderColor: 'var(--color-grey-50)',
                color: '#fff',
            } : {
                backgroundColor: isHovered ? 'var(--color-grey-95)' : '#fff',
                borderColor: 'var(--color-grey-70)',
                color: 'var(--color-grey-20)',
            }}
            className={`w-full h-[42px] px-4 border flex items-center justify-center gap-2.5 whitespace-normal text-center relative transition-colors duration-100 ease-in max-[267px]:leading-tight rounded-full ${disabled
                    ? 'opacity-60 cursor-not-allowed'
                    : 'cursor-pointer'
                }`}
        >
            <span className="flex items-center z-[2]">
                <img
                    src={icon}
                    className="w-6 h-6 flex-shrink-0"
                    alt=""
                    loading="lazy"
                    onError={(e) => {
                        // Hide the image if it fails to load to prevent console errors
                        e.currentTarget.style.display = 'none';
                    }}
                />
            </span>
            <span className="flex-1 flex justify-center items-center z-[1]">
                {text}
            </span>
        </button>
    );
});

export default LoginButton;
